export default __webpack_public_path__ + "static/media/studio2.abafdcc8.jpeg";